module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/fallback_160_160_44edde6.png";